module.exports = __webpack_public_path__ + "static/img/bg-en.b6ea9ba0.webp";